export default "__VITE_ASSET__6439f3c9__"